import Vue from 'vue';
import App from './index.vue';
import router from './router';
import '../../assets/js/rem';
import '@/utils/hm.js';
import { Popup, Field, Picker, Search,Cascader,List,Cell,Icon  } from 'vant';
import Loading from '../../../src/components/toggleloading/config';
import CM from '@/utils/common';
import WxJssdk from '@mxc/wx-jssdk';
import ARMS from '@/utils/BrowserLogger.js';
import directives from '@mxc/v-directive';
import wxConfigInit from '@/utils/wx-config';
Vue.config.ignoredElements = ['wx-open-subscribe'];
import { lazyLoad } from '@mxc/vue-element';
// 公众号配置-全局路由守卫
wxConfigInit(router);

new directives({ vm: Vue });
window.WxJssdk = WxJssdk;
Vue.use(Loading);
Vue.prototype.$CM = CM;
Vue.config.productionTip = false;

Vue.use(Picker);
Vue.use(Search);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Cascader);
Vue.use(List);
Vue.use(Cell);
Vue.use(Icon);
Vue.use(lazyLoad);

ARMS('landing-page');
new Vue({
  router,
  render: h => h(App),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/pages/landing-page/index.js